/**
 * Descendant selector matching the scheme MUI stamps on <html> when the Kaizen
 * theme's cssVariables are active. The legacy theme never sets the attribute,
 * so rules under it only ever match with the Kaizen theme mounted in dark.
 */
export const DARK_SCHEME = '[data-mui-color-scheme="dark"] &';

// A translucent wash of the page ground, laid over brand artwork so it settles
// into the dark chrome instead of glowing. Two stops of the same color make a
// flat scrim layer that stacks over the original background.
const groundScrim =
  "color-mix(in srgb, var(--ds-mui-palette-background-default) 45%, transparent)";

/** `background` with the dark ground washed over it. */
export const scrimOver = (background: string): string =>
  `linear-gradient(${groundScrim}, ${groundScrim}), ${background}`;
